"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = exports["default"] = {
  /*'/branches': {
  	title: 'Branches',
  	view: 'Branches',
  	public: true,
  	locales: {
  		az: '/az/branches',
  		en: '/en/branches',
  		ru: '/ru/branches',
  	}
  },
  '/az/branches': {ref: '/branches', lang: 'az', title: 'Branches'},
  '/en/branches': {ref: '/branches', lang: 'en', title: 'Branches'},
  '/ru/branches': {ref: '/branches', lang: 'ru', title: 'Branches'},*/
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6W10sInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vLi4vLi4vbGlicmFyeS9zcmMtY2xpZW50L21vZHVsZXMvQ29udGVudC9CcmFuY2gvQnJhbmNoUm91dGVzLmpzIl0sInNvdXJjZXNDb250ZW50IjpbImV4cG9ydCBkZWZhdWx0IHtcblx0LyonL2JyYW5jaGVzJzoge1xuXHRcdHRpdGxlOiAnQnJhbmNoZXMnLFxuXHRcdHZpZXc6ICdCcmFuY2hlcycsXG5cdFx0cHVibGljOiB0cnVlLFxuXHRcdGxvY2FsZXM6IHtcblx0XHRcdGF6OiAnL2F6L2JyYW5jaGVzJyxcblx0XHRcdGVuOiAnL2VuL2JyYW5jaGVzJyxcblx0XHRcdHJ1OiAnL3J1L2JyYW5jaGVzJyxcblx0XHR9XG5cdH0sXG5cdCcvYXovYnJhbmNoZXMnOiB7cmVmOiAnL2JyYW5jaGVzJywgbGFuZzogJ2F6JywgdGl0bGU6ICdCcmFuY2hlcyd9LFxuXHQnL2VuL2JyYW5jaGVzJzoge3JlZjogJy9icmFuY2hlcycsIGxhbmc6ICdlbicsIHRpdGxlOiAnQnJhbmNoZXMnfSxcblx0Jy9ydS9icmFuY2hlcyc6IHtyZWY6ICcvYnJhbmNoZXMnLCBsYW5nOiAncnUnLCB0aXRsZTogJ0JyYW5jaGVzJ30sKi9cbn1cbiJdLCJtYXBwaW5ncyI6Ijs7Ozs7O29DQUFlO0VBQ2Q7QUFDRDtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFaQyxDQWFBIiwiaWdub3JlTGlzdCI6W119